import makeFetch from "../../utils/http";

export function api_getEmployers() {
    return makeFetch(
        "employers",
        "GET",
    );
}
